/**
 * ч.849 (рішення власника, новий дизайн сторінок документів):
 * пронумерований БЛОК полів редактора — «1 Основні дані», «2 Покупець і
 * договір» тощо. Заголовок + підказка праворуч від назви, поля всередині.
 *
 * Прогрес заповнення (права колонка) рахує ЛИШЕ ОБОВʼЯЗКОВІ поля блоку
 * (рішення власника): `required` — скільки обовʼязкових, `filled` — скільки
 * з них заповнено. Блок без обовʼязкових полів вважається виконаним.
 */
import type { ReactNode } from 'react';

export interface DocBlockState {
  id: string;
  /** Номер + назва у правій колонці. */
  title: string;
  /** Обовʼязкових полів у блоці (0 — блок без обовʼязкових). */
  required?: number;
  /** Скільки обовʼязкових заповнено. */
  filled?: number;
}

export function blockDone(b: DocBlockState): boolean {
  const req = b.required ?? 0;
  return req === 0 ? true : (b.filled ?? 0) >= req;
}

export default function DocBlock({ index, title, hint, children, actions }: {
  /** ч.883: без index — блок без кружечка-номера (картки довідників). */
  index?: number;
  title: string;
  hint?: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="docblock" data-testid={`docblock-${index ?? title}`}>
      <div className="docblock__head">
        {index !== undefined && <span className="docblock__num" aria-hidden>{index}</span>}
        <h3 className="docblock__title">{title}</h3>
        {hint && <span className="docblock__hint">{hint}</span>}
        {actions && <div className="docblock__actions">{actions}</div>}
      </div>
      <div className="docblock__body">{children}</div>
    </section>
  );
}
